module.exports = __webpack_public_path__ + "img/guide_tips_btn.cd19530f.png";